import { api } from "@/lib/api";

const CHUNK = 2 * 1024 * 1024;

/** Caricamento a blocchi (2 MB) di un manuale PDF: init → chunk → complete (verifica SHA lato server, OCR locale in background). */
export async function uploadManual(file, { allowUnlisted = false, onProgress } = {}) {
  const total = Math.max(1, Math.ceil(file.size / CHUNK));
  const init = await api.post("/knowledge-manuals/uploads", { filename: file.name, size: file.size, total_chunks: total, allow_unlisted: allowUnlisted });
  const id = init.data.upload_id;
  for (let i = 0; i < total; i++) {
    const fd = new FormData();
    fd.append("chunk", file.slice(i * CHUNK, (i + 1) * CHUNK), `c${i}`);
    await api.put(`/knowledge-manuals/uploads/${id}/chunks/${i}`, fd, { timeout: 120000 });
    onProgress?.(Math.round(((i + 1) / total) * 90));
  }
  const done = await api.post(`/knowledge-manuals/uploads/${id}/complete`, {}, { timeout: 120000 });
  onProgress?.(100);
  return done.data;
}
